/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Diamond = (props: IconProps) => (
  <Icon {...props}>
    <path d="M12.1599 3H11.8399L9.20988 8.25H14.7899L12.1599 3ZM16.4599 8.25H21.6199L18.9999 3H13.8399L16.4599 8.25ZM21.3799 9.75H12.7499V20.1L21.3799 9.75ZM11.2499 20.1V9.75H2.61988L11.2499 20.1ZM7.53988 8.25L10.1599 3H4.99988L2.37988 8.25H7.53988Z" />
  </Icon>
);
